import React from 'react';
import { Check } from 'lucide-react';
import Checkbox from '../Forms/Input/Checkbox';

interface Feature {
  code: string;
  name: string;
  enabled?: boolean;
}

interface Props {
  features: Feature[];
  editing?: boolean;
  onToggle?: (code: string) => void;
  updatingFeatureCodes?: string[];
}

const SystemPlanFeatures: React.FC<Props> = ({
  features,
  editing,
  onToggle,
  updatingFeatureCodes = [],
}) => {
  const featureLabel = (feature: Feature) =>
    feature.code === 'DTE_TRANSMISSION'
      ? 'Transmisión a Hacienda'
      : feature.name;

  return (
    <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
      {features.map((feature) =>
        editing ? (
          <Checkbox
            key={feature.code}
            label={featureLabel(feature)}
            checked={!!feature.enabled}
            onChange={() => onToggle?.(feature.code)}
            disabled={updatingFeatureCodes.includes(feature.code)}
          />
        ) : (
          <div
            key={feature.code}
            className="text-gray-700 dark:text-gray-300 flex items-center gap-2 text-sm"
          >
            <Check size={16} className="shrink-0 text-green-500" />
            <span>{featureLabel(feature)}</span>
          </div>
        )
      )}
    </div>
  );
};

export default SystemPlanFeatures;
